import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type TaskListItem = ResultOf<
  typeof taskListQuery
>["tasks"]["data"][number];
export const taskListQuery = graphql(`
  query TaskList(
    $page: Int!
    $first: Int!
    $userId: ID
    $status: [TaskStatus!]
    $orgOnly: Boolean
    $supplierId: ID
    $where: QueryTasksWhereWhereConditions
    $orderBy: [QueryTasksOrderByOrderByClause!]
  ) {
    tasks(
      page: $page
      first: $first
      status: $status
      user_id: $userId
      orgOnly: $orgOnly
      supplier_id: $supplierId
      where: $where
      orderBy: $orderBy
    ) {
      data {
        id
        due_at
        status
        related_to_type
        related_to_id
        relatedTo {
          __typename
          ... on Booking {
            id
            reference
            relocation {
              supplier {
                id
                name
              }
            }
          }
          ... on BookingSupplierConfirmation {
            id
            booking_reference
            supplier_reference
            booking {
              id
              reference
              relocation {
                supplier {
                  id
                  name
                }
              }
            }
          }
          ... on RelocationLineEmail {
            id
            email_subject
            email_from
          }
          ... on WorkOrderAssignmentPayout {
            id
            amount
            amount_tax
            currency
            workOrderAssignment {
              id
              workOrder {
                id
                reference
                supplier {
                  id
                  name
                }
              }
            }
          }
          ... on WorkOrderAssignment {
            id
            proDriver {
              id
              name
            }
            workOrder {
              id
              reference
              supplier {
                id
                name
              }
            }
          }
        }
        due_at
        type
        description
        created_at
        updated_at
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);

export type TaskListData = ResultOf<
  typeof taskListQuery
>["tasks"]["data"][number];
